import { IonChip, IonIcon, IonItem, IonLabel, IonText } from '@ionic/react';
import { locationOutline } from 'ionicons/icons';
import { setLightness } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { Session } from '@custom-types/Session';
import { formatTimeRange } from '@services/date-service';
import { Locale } from '@services/language-service';

interface Props {
  session: Session;
  showBorder?: boolean;
  locale: Locale;
  onClick?: () => void;
}

const Chip = styled(IonChip)<{ $textColor: string }>`
  font-size: 12px;
  --color: ${({ $textColor }) => $textColor};
  --background: ${({ $textColor }) => setLightness(0.97, $textColor)};
  border-color: ${({ $textColor }) => setLightness(0.97, $textColor)};
`;

const Item = styled(IonItem)<{ $showBorder: boolean }>`
  --border-style: ${({ $showBorder }) => ($showBorder ? 'solid' : 'none')};
`;

const SessionItem = ({
  session: { name, startDatetime: utcStartDate, endDatetime: utcEndDate, location, tracks },
  locale,
  showBorder = true,
  onClick = undefined,
}: Props) => {
  const time = formatTimeRange({
    utcStartDate,
    utcEndDate,
    locale,
    is24HourFormat: false,
  });
  return (
    <Item onClick={onClick} $showBorder={showBorder}>
      <IonLabel>
        <IonText className="ion-text-wrap">
          <h2>{name}</h2>
        </IonText>
        <IonText color="medium">
          <h3>{time}</h3>
          {location?.label && (
            <h3>
              <IonIcon icon={locationOutline} />
              {location?.label}
            </h3>
          )}
        </IonText>
        {tracks?.map(track => (
          <Chip key={track.id} $textColor={track?.color ?? '#ffffff'}>
            <IonLabel>
              <IonText>{track?.name}</IonText>
            </IonLabel>
          </Chip>
        ))}
      </IonLabel>
    </Item>
  );
};

export default SessionItem;
